import React from 'react';
import {Link} from 'react-router-dom';
import {Container, Row, Col, CardDeck, Card, Button} from 'react-bootstrap';
import '../styles/components/display.css';

export const Display = () => {
    return (
    <>
      <Container className="backgroundVideo">
        <video rel="preload" autoPlay="autoplay" loop="loop" muted playsInline>
          <source rel="preload" src="/assets/videos/Display.mp4" type="video/mp4"/>
        </video>
      </Container>
     
      <Container fluid className="fablab-container" style={{backgroundColor:"var(--gray)", background:'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), ', backgroundSize: 'cover'}}> 
        <Row>
          <Col className="text-center">
            <Link to ="#"><img src ='./assets/images/logo-fablab.png' alt='Logo FabLab UTFSM' width='200px'/></Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <CardDeck>
              <Card className="cardDisplay cardYellow">
                <Card.Body className="text-center white">
                  <Card.Title>Soy nuevo</Card.Title>
                  <Card.Text>¡Conoce sobre FabLab UTFSM por acá!</Card.Text>
                  <Link to="/conocenos"><Button className="">Conócenos</Button></Link>
                </Card.Body>
              </Card>
              
              <Card className="cardDisplay cardRed">
                <Card.Body className="text-center white">
                  <Card.Title>Portal</Card.Title>
                  <Card.Text>Si ya tiene una cuenta y quiere reservar una máquina o inscribir un proyecto</Card.Text>
                  <Link to="/Portal"><Button className="fablab-button" href="https://dev.portal.fablab.usm.cl/">Acceso alumnos con Pasaporte USM</Button></Link>
                </Card.Body>
              </Card>

              <Card className="cardDisplay cardBlue">
                <Card.Body className="text-center white">
                  <Card.Title>Classroom</Card.Title>
                  <Card.Text>Si ya tiene una cuenta y quiere capacitarse o participar de un taller</Card.Text>
                  <Link to="/classroom"><Button className="fablab-button" href="https://www.classroom.fablab.usm.cl">Acceder con Pasaporte USM o cuenta FabLab</Button></Link>
                </Card.Body>
              </Card>
            </CardDeck>
          </Col>
        </Row>
      </Container>
    </>
  )
}
